import { IFileAttachment } from '../../../../extViewmodels';
import { isRedrawable } from '../../../components-v2/UnifiedImageDialog/redrawableMedia';

export const isVideoAttachment = (attachment: IFileAttachment) =>
	!!attachment.mimeType?.toLowerCase().startsWith('video/');

export const isImageAttachment = (attachment: IFileAttachment) =>
	!!attachment.mimeType?.toLowerCase().startsWith('image/');

/**
 */
export const getRebrandBlockedReason = (media: readonly IFileAttachment[], hasBranding: boolean) => {
	if (!hasBranding) {
		return 'Your account has no brand settings yet';
	}
	if (media.some(isImageAttachment)) {
		return undefined;
	}
	return media.length ? 'Branding applies to images, not videos' : 'Add an image to apply your branding';
};

/** A crop redraws a still, so a video or an animated GIF has nothing it can keep. */
export const getCropBlockedReason = (media: readonly IFileAttachment[]) => {
	if (media.some(isRedrawable)) {
		return undefined;
	}
	return media.length ? 'Videos and GIFs can’t be cropped' : 'Add an image to crop it';
};

/** The publisher burns the logo onto images only, never onto a video. */
export const getLogoOverlayBlockedReason = (media: readonly IFileAttachment[]) => {
	if (media.some(attachment => !isVideoAttachment(attachment))) {
		return undefined;
	}
	return media.length ? 'Your logo goes on images, not videos' : 'Add an image to see your logo on it';
};
